/* eslint-disable prefer-destructuring */
import React from 'react'
import { Text, TouchableWithoutFeedback, View } from 'react-native'
import PropTypes from 'prop-types'
import styles from '../../styles'

export default function Hyperlink(props) {
  const {
    testID, style, linkText, beforeText, afterText, onPress, textStyle, accessibilityLabel,
  } = props
  let beforeTextTOUse = beforeText
  let afterTextToUse = afterText
  if (beforeText.includes('http://callLink')) {
    const texts = beforeText.split('http://callLink')
    beforeTextTOUse = texts[0]
    afterTextToUse = texts[1]
  }

  return (
    <View style={{ flex: 1 }}>
      <TouchableWithoutFeedback
        accessibilityLabel={accessibilityLabel}
        testID={testID}
        onPress={onPress}
        style={style}
      >
        <View>
          <Text style={textStyle}>
            {beforeTextTOUse}
            <Text style={onPress ? styles.hyperlink : textStyle}>
              {beforeTextTOUse ? ` ${linkText}` : linkText}
            </Text>
            {afterTextToUse}
          </Text>
        </View>
      </TouchableWithoutFeedback>
    </View>
  )
}

Hyperlink.propTypes = {
  testID: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  beforeText: PropTypes.string,
  afterText: PropTypes.string,
  onPress: PropTypes.func,
  accessibilityLabel: PropTypes.string,
  textStyle: PropTypes.instanceOf(Object),
  style: PropTypes.instanceOf(Object),
}

Hyperlink.defaultProps = {
  // hyperLinkStyle: styles.hyperlink,
  textStyle: styles.shark_grey,
  beforeText: '',
  afterText: '',
  accessibilityLabel: null,
  onPress: null,
  style: null,
}
